<!--
 * @Author: 
 * @Date: 2023-03-02 20:49:56
 * @LastEditors: Yuan Wei Lin
 * @LastEditTime: 2023-03-06 14:54:09
 * @Description: 
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style lang="less">
</style>
